import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Search input with icon (input-group). Used in DataTable filters, modals, and user asset search.
 */
export default function SearchField({
  id,
  value,
  onChange,
  placeholder = 'Search…',
  className,
  style,
  inputClassName,
  autoComplete = 'off',
  inputRef,
  'aria-label': ariaLabel,
}) {
  return (
    <div className={classNames('input-group', className)} style={style}>
      <span className="input-group-text bg-white border-end-0">
        <i className="bi bi-search" aria-hidden />
      </span>
      <input
        ref={inputRef}
        id={id}
        type="search"
        className={classNames('form-control border-start-0', inputClassName)}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        aria-label={ariaLabel || placeholder}
      />
    </div>
  );
}

SearchField.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  inputClassName: PropTypes.string,
  autoComplete: PropTypes.string,
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
  'aria-label': PropTypes.string,
};

SearchField.defaultProps = {
  id: undefined,
  value: '',
  placeholder: 'Search…',
  className: '',
  style: undefined,
  inputClassName: '',
  autoComplete: 'off',
  'aria-label': undefined,
};
